/**
 * A animação de troca de página é por TELA, não por endereço: trocar de
 * conversa (/chat/a → /chat/b → /chat) é a mesma tela — sem fade, sem
 * desmontar e recarregar a lista (o ESC escurecia a tela inteira, 2026-10-28).
 * Vale igual para as conversas do WhatsApp e do Assistente da Central de
 * Projetos (criar a conversa troca /assistente/nova por /assistente/12).
 */
const TELAS_DE_CONVERSA = Object.freeze(["/chat", "/central-projetos/conversas", "/central-projetos/assistente"]);

/**
 * Telas que animam a troca entre lista e ficha por conta própria (View
 * Transitions, com nome e anel do cliente como elemento compartilhado): a
 * troca não pode esperar o fade de saída da página.
 */
const TELAS_COM_TRANSICAO_PROPRIA = Object.freeze(["/legado/clientes"]);

/** Telas que ocupam a altura toda, sem rolagem da página (cada painel rola sozinho). */
const TELAS_DE_ALTURA_CHEIA = TELAS_DE_CONVERSA;

function telaDe(pathname, telas) {
  return telas.find((base) => pathname === base || pathname.startsWith(`${base}/`)) || null;
}

export function ehTelaDeAlturaCheia(pathname) {
  return telaDe(pathname, TELAS_DE_ALTURA_CHEIA) !== null;
}

export function chaveDaTransicao(pathname) {
  return telaDe(pathname, TELAS_DE_CONVERSA) || telaDe(pathname, TELAS_COM_TRANSICAO_PROPRIA) || pathname;
}
